export default __webpack_public_path__ + "static/about-map-3df346f4c3fe0bfd9f64bbd9d29ef444.png";